<template>
	<div class="result-screen">
		<div v-if="is_annotation" v-html="annotation"></div>

		<div class="button-section">
			<div class="step-btn" @click="onStart">
				Пройти повторно
			</div>
			<form method="POST" name="pdf_form" id="pdf_form" action="/requests/navigator/get_result_pdf">
				<input type="hidden" name="htmlText" id="htmlText"/>
				<input type="hidden" name="request_id" id="pdf_request_id"/>
				<div class="step-btn" @click="getPDFFile">
					Скачать PDF
				</div>
			</form>
		</div>
		<div class="main-result-step">
			<div class="result-title">
				Базовая дорожная карта по возможным шагам реализации Вашего инвестиционного проекта
			</div>
			<div class="result-created">
				Дата составления: <span class="result-created-date">{{ created_date }}</span>
			</div>

			<div class="step-result">
				<template v-for="result in resultData">
					<div class="step-header">
						{{ result.name }}
					</div>

					<div class="step-container">
						<div class="step-item" v-html="item" v-for="item in result.items"></div>
					</div>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: [],
		data() {
			return {
				resultData: {},
				created_date: '',
				annotation: '',
				is_annotation: false
			}
		},
		methods: {
			getResultData() {
				let params = $('#request_id').val() + "?alias=" + alias;
				this.$http.get("/requests/navigator/get_result/" + params).then(response => {
		          if (response.body.msg) {
		            response.body.is_error ? showErrorMessage(response.body.msg) : showLoaded(response.body.msg);
		          }
		          if (response.body.is_error) {
		            return;
		          }
		          this.resultData = response.body.step_info;
		          this.created_date = response.body.created_date;
		          this.annotation = response.body.annotation;
		          this.is_annotation = false;
		          if(response.body.annotation && response.body.annotation.length > 0) {
		          	this.is_annotation = true;
		          }
		        }, response => {
		          showErrorMessage("Ошибка запроса.")
		        });
			},
			onStart() {
				this.$emit('onStart');
			},
			getPDFFile() {
				$('#pdf_request_id').val($('#request_id').val());
				$('#pdf_form').submit();
			}
		},
		mounted() {
	    	this.getResultData();
	 	}
	}
</script>

<style id="result-style">
	.result-screen {

	}

	.result-title {
		padding: 10px;
		text-align: center;
		font-size: 22px;
	}

	.result-created {
		padding: 10px;
		text-transform: uppercase;
		color: #36A8DA;
		margin-bottom: -15px;
	}

	.result-created-date {
		color: #199CD5;
		font-weight: bold;
	}

	.step-header {
		margin-top:25px;
		background-color: #CCEEF6;
		padding: 15px;
		font-size: 21px;
	}

	.step-container {
		padding: 0
	}

	.step-item {
		padding: 15px;
	}

	.step-item:nth-child(2n) {
		background-color: #f0f0f0;
	}

	.button-section {
		display: flex;
		justify-content:flex-start;
		flex-wrap: wrap;
	}

	.step-btn {
		width: 250px;
		margin: 10px 0 20px 20px;
		text-align: center;
		padding: 12px 0;
		background-color: #337AB7;
		font-size: 16px;
		text-transform: uppercase;
		cursor: pointer;
		color: #fff;
	}

	.step-btn:hover {
		background-color: #0D3A73;
	}
</style>



// WEBPACK FOOTER //
// src/components/ResultScreen.vue